import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import PageLayout from '../../components/PageLayout'
import { DeclarationContext, declarationData } from './DeclarationPage'
import { Sector } from '../../../common/Text'
import LabelField from '../../../common/LabelField'
import moment from 'moment'
import { get } from 'lodash'
import { AppContext } from '../../Context'
import Button from '../../../common/Button'
import DeclarationLine from './DeclarationLine'
import theme from '../../../common/theme'
import RecordAttachmentUploader from '../../components/RecordAttachmentUploader'
import { getDeclarations } from '../../services/declaration-services'
import { getBabysittingModeFrom } from '../../../common/BabysittingModes'
import { RecordStatus } from '../../../common/Constants'
import { generateDeclarationMonthList } from '../../../common/util'

const Container = styled(PageLayout)`
  .content {
    margin: 0;
   > span {
      margin: 0 20px 10px 20px;
   }
   > .row {
       margin: 0 20px 22px 20px;
       display: flex;
       flex-wrap: wrap;
       .field {
          flex: 1;
       }
   }
   > .change-babysitting{
      margin: 0 20px 22px 20px;
      
      > .upload-zone{
        margin-top: 10px;
      }
   }
  .declaration-line {
    margin-bottom: 5px;
    font-size: 13px;
  }
  .year {
    font-size: 12px;
    color: ${ theme.palette.dark_blue };
    font-weight: bold;
    line-height: 14px;
    margin: 0 0 5px 20px;
  }
  .declaration-detail-sector-separator {
    margin-top: 20px;
  }
 }
`
export default function DeclarationDetail({ ...props }) {

  const { babysittingModes, attachmentConfig, recordAttachConfig } = useContext(AppContext)
  const { recordId, record, parentHistory, setRecord } = useContext(DeclarationContext)

  const [declarations, setDeclarations] = useState(null)
  const [months, setMonths] = useState([])
  const [hasMore, setHasMore] = useState(false)
  const [offsetDate, setOffsetDate] = useState(null)
  const [showUploadFile, setShowUploadFile] = useState(false)

  useEffect(() => {
    if (record && declarations) {
      const minActiveDate = moment().subtract(2, 'months').startOf('month').utcOffset(0, true)
      const newOffset = offsetDate ? offsetDate : minActiveDate
      generateMonthList(null, newOffset, true, declarations, record)
    }
  }, [record, declarations])

  useEffect(() => {
    const fetch = async () => {
      const resp = await getDeclarations(recordId, declarationData)
      if (resp.data.getDeclarations) {
        setDeclarations(resp.data.getDeclarations)
      }
    }
    if (recordId) {
      fetch()
    }
  }, [recordId])

  const generateMonthList = (start, end, reset, declarations, record) => {
    const {
      listMonths,
      more,
      offset
    } = generateDeclarationMonthList(start, end, declarations, record)
    if (reset) {
      setMonths(listMonths)
    } else if (listMonths) {
      setMonths([...months, ...listMonths])
    }
    setHasMore(more)
    setOffsetDate(offset)
  }

  const showMore = () => {
    const newOffset = moment(offsetDate).subtract(12, 'months')
    generateMonthList(moment(offsetDate).subtract(1, 'months'), newOffset, false, declarations, record)
  }

  return record && <Container
    title={ `Mon dossier n° ${ record.reference } ` }
    onPrevious={ () => parentHistory.push('/') }
  >
    <Sector>Informations</Sector>
    <div className="row">
      <LabelField label={ 'Nom' } subLabelUnderline={ true }>
        { get(record, 'child.firstName') } { get(record, 'child.lastName') }
      </LabelField>
      <LabelField label={ 'Date de naissance' } subLabelUnderline={ true }>
        { moment(get(record, 'child.dateOfBirth')).format('DD/MM/YYYY') }
      </LabelField>
    </div>
    <div className="row">
      <LabelField label={ 'Mode de garde' } subLabelUnderline={ true }>
        { getBabysittingModeFrom(babysittingModes, record.babysittingMode, 'name') }
      </LabelField>
      <LabelField label={ 'Dossier validé le' } subLabelUnderline={ true }>
        { moment(record.validateDate).format('DD/MM/YYYY') }
      </LabelField>
    </div>

    <Sector>Mes déclarations mensuelles</Sector>
    {
      (months && months.length > 0) && months.map((month, index) => {
        return <DeclarationLine key={ month.date } month={ month }/>
      })
    }
    { hasMore &&
    <div className="row"><Button className="clear" onClick={ showMore }>Afficher plus de déclarations</Button></div> }

    <Sector className="declaration-detail-sector-separator">J’informe d’un changement dans mon dossier</Sector>
    <div className="change-babysitting">
      Un autre contrat de garde pour mon enfant, une demande d’extension, ... ?
      <div className="upload-zone">
        { !showUploadFile ?
          <Button className="clear" onClick={ () => setShowUploadFile(true) }>Intégrer vos justificatifs
            complémentaires</Button> :
          <RecordAttachmentUploader
            showFiles={ false }
            showLabel={ false }
            attachConfig={ recordAttachConfig.find(config => config.category === 'babysitting_supp') }
            uploadConfig={ attachmentConfig }
            record={ record }
            setRecord={ setRecord }
            event={ RecordStatus.ADD_BABYSITTING_MODE }
          />
        }
      </div>
    </div>
  </Container>
}
